const digitsOnly = (value) => {
  if (value == null) return "";
  return String(value).replace(/\D/g, "");
};

export const maskSSN = (value) => {
  const digits = digitsOnly(value);
  if (!digits) return "";
  if (digits.length === 9) return `*****${digits.slice(-4)}`;
  if (digits.length > 4) {
    return `${"*".repeat(Math.max(0, digits.length - 4))}${digits.slice(-4)}`;
  }
  return value || "";
};

export const maskPhone = (value) => {
  const digits = digitsOnly(value);
  if (digits.length >= 4) {
    const lastFour = digits.slice(-4);
    return `(***) ***-${lastFour}`;
  }
  return value || "";
};

export const maskEmail = (value) => {
  if (!value) return "";
  const [local = "", domain = ""] = String(value).split("@");
  if (!domain) return value;
  if (!local) return `***@${domain}`;
  return `${local[0]}***@${domain}`;
};

export const getLastFour = (value) => {
  if (value == null) return "";
  const str = String(value);
  return str.slice(-4);
};

export const maskAccountNumber = (value, { wrap = true, prefix = "...", separator = "" } = {}) => {
  const lastFour = getLastFour(value);
  if (!lastFour) return "";
  const maskedCore = `${prefix}${separator}${lastFour}`.trim();
  if (!wrap) return maskedCore;
  return `(${maskedCore})`;
};

export const maskPhoneOrFallback = (value, fallback = "") => {
  const masked = maskPhone(value);
  return masked || fallback;
};


